"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _client = require("@apollo/client");

var _templateObject;

var _default = (0, _client.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  mutation enterpriseAgentSignUp($input: EnterpriseAgentSignUpInput) {\n    id\n    firstName\n    lastName\n    email\n    profile {\n      id\n    }\n  }\n"])));

exports["default"] = _default;